import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Path 707-2",
  "use": "icon-Path 707-2-usage",
  "viewBox": "0 0 14.871 26.743",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.871 26.743\" id=\"icon-Path 707-2\">\n  <path id=\"icon-Path 707-2_Path_707\" data-name=\"Path 707\" d=\"M25,2.5,13.75,13.75,2.5,2.5\" transform=\"translate(-0.379 27.121) rotate(-90)\" fill=\"none\" stroke=\"#e0592a\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" stroke-width=\"3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Path 707-2.svg
// module id = jWiy
// module chunks = 3